import React, { useState, useEffect } from "react";
import styles from "./rapolasLogo.module.scss";

export default function BigRapolasLogo() {
  return (
    <div className={styles.bigLogoBackground}>
      <div className={styles.bigLogoS}>
        S <span className={styles.bigLogoR}>R</span>
      </div>
    </div>
  );
}
